import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import {
  faSignOutAlt, faSearch, faTimes, faPlus,
} from '@fortawesome/free-solid-svg-icons';
import {
  List, Skeleton, Button, Tag, Input, Modal,
} from 'antd';
import 'react-table/react-table.css';
import CountUp from 'react-countup';
import { Holdable, defineHold } from 'react-touch';
import { setTitleAction } from '../../../state/actions/creators/app.actioncreator';
import {
  getNoConformidadesAction,
  seleccionarNoConformidadAction,
  resetNoConformidades,
  deseleccionarNoConformidadAction,
} from '../../../state/actions/creators/noconformidades/noconformidades.actioncreator';
import {
  logoutAction,
} from '../../../state/actions/creators/auth.actioncreator';
import { addNotificacion } from '../../../state/actions/creators/sistemaNotificaciones/notificaciones.actioncreator';
import {
  Box, Text, FloatingButton,
} from '../../shared/components';
import HeaderPageLayout from '../../app/layout/headerPage.layout';
import debounce from '../../../helpers/debounce';
import {
  uploadPhotosAction,
} from '../../../state/actions/creators/sistemaSubidaFotografias/fotografias.actioncreator';

const holdConfig = defineHold({ updateEvery: 50, holdFor: 500 });

function renderFecha(fechaCreacion) {
  let fechaCreacionAux = '';
  if (fechaCreacion) {
    fechaCreacionAux = fechaCreacion.split('-');
    fechaCreacionAux = `${fechaCreacionAux[2]}/${fechaCreacionAux[1]}/${fechaCreacionAux[0]}`;
  }

  return fechaCreacionAux;
}

class NoConformidades extends Component {
  debouncedSearch = debounce((text) => {
    const { getNoConformidadesAction, resetNoConformidades } = this.props;
    resetNoConformidades();
    getNoConformidadesAction(1, 0, 25, text);
  }, 500);

  constructor() {
    super();
    this.state = {
      searchOpened: false,
      searchText: '',
      listItemIdTouched: null,
      modalLogout: null,
    };
  }

  componentDidMount() {
    const {
      getNoConformidadesAction,
      noConformidades,
      deseleccionarNoConformidadAction,
      uploadPhotosAction,
      sistemaSubidaFotografias: { recursos: recursosPendientes },

    } = this.props;
    const { listado } = noConformidades;
    if (listado.length === 0) {
      getNoConformidadesAction(1, 0, 25);
    }
    this.addPhotosPendientes();
    deseleccionarNoConformidadAction();
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  onClickGestionar(noConformidadSeleccionada) {
    const {
      seleccionarNoConformidadAction, history, auth, noConformidades,
    } = this.props;
    const { permisos } = auth || {};
    const { nc_lis: puedeVerNc } = permisos || {};
    const { seleccionada } = noConformidades;

    if (puedeVerNc && !(seleccionada.hasOwnProperty('id'))) {
      seleccionarNoConformidadAction(noConformidadSeleccionada);
      history.push(`/noconformidades/mostrar/${noConformidadSeleccionada.id}`);
    }
  }


  onClickEditar(noConformidadSeleccionada) {
    const { seleccionarNoConformidadAction, history } = this.props;
    seleccionarNoConformidadAction(noConformidadSeleccionada);
    history.push(`/noconformidades/editar/${noConformidadSeleccionada.id}`);
  }

  onClickCrear() {
    const { history, deseleccionarNoConformidadAction } = this.props;
    deseleccionarNoConformidadAction();
    history.push('/noconformidades/crear');
  }

  getActionButtons() {
    const { appIsOnline, addNotificacion } = this.props;

    return (
      <Box style={{
        display: 'flex', justifyContent: 'space-between', width: '100%',
      }}
      >
        <Box flex={1}>
          <Button
            type="link"
            shape="circle"
            onClick={() => {
              if (!appIsOnline) {
                addNotificacion('No dispone de conexión a internet');
                this.setState({ searchOpened: false });
              } else {
                this.setState({ searchOpened: true });
              }
            }}
          >
            {' '}
            <FontAwesomeIcon icon={faSearch} />
          </Button>
        </Box>
        <Box id="secondBtnHeader" flex={1}>
          <Button type="link" shape="circle" onClick={() => this.confirm()}>
            {' '}
            <FontAwesomeIcon icon={faSignOutAlt} />
          </Button>
        </Box>
      </Box>
    );
  }

  getNavigationButtons() {
    const { appIsOnline, addNotificacion } = this.props;

    return (
      <Box />
    );
  }

  onCloseSearch() {
    this.handleSearh('');
    this.setState({ searchOpened: false });
  }

  getListItemButtons(item, isSelected) {
    if (item.loading) return null;

    const { auth } = this.props;
    const { permisos } = auth || {};
    let { nc_editar: puedeEditarNc, nc_lis: puedeVerNc } = permisos || {};
    puedeEditarNc = (typeof (puedeEditarNc) === 'undefined') ? false : puedeEditarNc;
    puedeVerNc = (typeof (puedeVerNc) === 'undefined') ? false : puedeVerNc;
    let buttonText = '';

    if (isSelected) {
      buttonText = (puedeEditarNc) ? 'Editar' : '';
      return [<Button style={{ fontWeight: 'bold' }} type="link" onClick={() => this.onClickEditar(item)}>{buttonText}</Button>];
    }
    return [];
  }

  handleScroll = () => {
    if (document.documentElement.scrollTop + document.documentElement.clientHeight
      >= document.documentElement.scrollHeight - 100) {
      this.obtenerSucesivasNoConformidades();
    }
  };


  async addPhotosPendientes() {
    const {
      uploadPhotosAction,
      sistemaSubidaFotografias: { recursos: recursosPendientes },
    } = this.props;

    if (recursosPendientes.length > 0) {
      await uploadPhotosAction(recursosPendientes);
    }
  }

  confirm() {
    this.setState({
      modalLogout: (Modal.confirm({
        title: '¿Seguro que quieres salir de Qualitas?',
        content: '',
        okText: 'Salir',
        cancelText: 'Cancelar',
        icon: null,
        style: { textAlign: 'center' },
        className: 'logoutApp',
        onOk: e => this.okLogout(e),
      })),
    });
  }


  okLogout(e) {
    const { logoutAction } = this.props;
    const { modalLogout } = this.state;
    if (modalLogout) modalLogout.destroy();
    logoutAction();
  }

  obtenerSucesivasNoConformidades() {
    const { noConformidades, getNoConformidadesAction } = this.props;
    const { searchText } = this.state;
    const {
      page, start, limit, total,
    } = noConformidades;

    const valoresCargadosPagina = page * limit;
    if (valoresCargadosPagina < total) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = document.documentElement.scrollTop - 150;
      getNoConformidadesAction(page + 1, start + limit, limit, searchText);
    }
  }

  handleSearh(text) {
    this.setState({ searchText: text });
    if ((text.length > 3) || (text.length === 0)) {
      this.debouncedSearch(text);
    }
  }

  resetListado() {
    const { getNoConformidadesAction, resetNoConformidades } = this.props;
    resetNoConformidades();
    getNoConformidadesAction(1, 0, 25);
    this.setState({ searchOpened: false, searchText: '' });
  }

  overrideHeader() {
    const { searchOpened, searchText } = this.state;
    const { appIsOnline } = this.props;
    if (!appIsOnline) return undefined;
    if (!searchOpened) return undefined;
    return (
      <>
        <Box flex={9} pl={4}>
          <Input onChange={event => this.handleSearh(event.target.value)} value={searchText} autoFocus className="headerSearchInput" placeholder="Buscar" />
        </Box>
        <Box flex={1}>
          <Button pr={8} type="link" shape="circle" onClick={() => this.onCloseSearch()}>
            {' '}
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Box>
      </>
    );
  }


  render() {
    const {
      noConformidades, seleccionarNoConformidadAction, deseleccionarNoConformidadAction, auth,
    } = this.props;
    const { listItemIdTouched } = this.state;

    const { permisos } = auth || {};
    let { nc_crear: puedeCrearNc } = permisos || {};
    if (typeof (puedeCrearNc) === 'undefined') {
      puedeCrearNc = false;
    }
    const {
      listado, loading, limit, totalNcVencidas,
      totalNcConAcciones,
      totalNcActivas,
      esListadoFiltrado, seleccionada,
    } = noConformidades;
    const skeletonListado = [];
    if (loading) {
      for (let i = 0; i < limit; i += 1) {
        skeletonListado.push({ loading: true });
      }
    }


    return (

      <HeaderPageLayout
        overrideHeader={this.overrideHeader()}
        title="No Conformidades"
        p={2}
        actionButtons={this.getActionButtons()}
        navigationButton={this.getNavigationButtons()}
      >
        <Box>
          <Box
            p={2}
            style={{
              color: '#8798AD',
              fontFamily: 'Rubik',
              fontSize: '12px',
              letterSpacing: '1.21px',
              lineHeight: '15px',
              borderColor: '#8798AD',
              position: 'relative',
              marginTop: '16px',
            }}
          >
            <Text id="titlePageNc" mr={2}>TOTAL REGISTROS</Text>

            <Tag
              style={{
                borderRadius: '10px',
                backgroundColor: 'rgba(0,135,194,0.25)',
                color: '#0087C2',
                height: '22px',
                width: '32px',
                textAlign: 'center',
                fontWeight: '300',
                lineHeight: '20px',
                bottom: '12px',
                position: 'absolute',
                left: '150px',
              }}
            >
              <CountUp end={totalNcActivas} />

            </Tag>

            <Tag
              style={{
                borderRadius: '10px',
                backgroundColor: 'rgba(194,34,0,0.25)',
                color: '#C22200',
                height: '22px',
                width: '32px',
                textAlign: 'center',
                fontWeight: '300',
                lineHeight: '20px',
                bottom: '12px',
                position: 'absolute',
                left: '190px',
              }}
            >
              <CountUp end={totalNcVencidas} />
            </Tag>

            <Tag
              style={{
                borderRadius: '10px',
                backgroundColor: '#CCEBE0',
                color: '#039E68',
                height: '22px',
                width: '32px',
                textAlign: 'center',
                fontWeight: '300',
                lineHeight: '20px',
                bottom: '12px',
                position: 'absolute',
                left: '229px',
              }}
            >
              <CountUp end={totalNcConAcciones} />
            </Tag>


          </Box>
          { (listado.length > 0) ? (
            <List
              itemLayout="horizontal"
              dataSource={listado}
              renderItem={(item) => {
                const itemIsSelected = (seleccionada && item.id === seleccionada.id);
                const itemIsTouched = (listItemIdTouched && item.id === listItemIdTouched);

                return (
                  <Holdable
                    config={holdConfig}
                    onHoldComplete={() => seleccionarNoConformidadAction(item)}
                  >
                    <List.Item
                      className={itemIsTouched && !itemIsSelected ? 'horus-ant-list-item-touched' : null}
                      onTouchStart={() => {
                        if (!itemIsSelected) { deseleccionarNoConformidadAction(); }
                        this.setState({ listItemIdTouched: item.id });
                      }}
                      onTouchEnd={() => this.setState({ listItemIdTouched: null })}
                      onClick={() => this.onClickGestionar(item)}
                      style={{ borderLeft: `2px ${item.color_estado} solid`, marginBottom: '16px', backgroundColor: (itemIsSelected) ? 'rgb(217, 246, 246)' : '#fff' }}
                      actions={this.getListItemButtons(item, itemIsSelected)}

                    >
                      <List.Item.Meta
                        title={(
                          <Text
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: 'vertical',
                              color: '#2E384D',
                              fontFamily: 'Open Sans',
                              fontSize: '15px',
                              lineHeight: '20px',
                            }}
                          >
                            {item.nombre}

                          </Text>
                        )}
                        description={(
                          <Text
                            style={{
                              color: '#8798AD',
                              fontFamily: 'Open Sans',
                              fontSize: '15px',
                              lineHeight: '22px',
                            }}
                          >
                            {renderFecha(item.fecha_creacion)}
                          </Text>
                        )}
                       //
                      />
                    </List.Item>
                  </Holdable>
                );
              }}
            />
          ) : null}
          { skeletonListado.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={skeletonListado}
              renderItem={item => (
                <List.Item
                  style={{ borderLeft: `2px ${item.color_estado} solid`, marginBottom: '16px', backgroundColor: '#fff' }}
                >
                  <Skeleton title={false} loading={item.loading} active>
                    <List.Item.Meta
                      title="..."
                      description="..."
                    />
                  </Skeleton>
                </List.Item>
              )}
            />
          ) : null}

          <FloatingButton onClick={() => this.onClickCrear()} icon={faPlus} show={puedeCrearNc} />
        </Box>
      </HeaderPageLayout>
    );
  }
}

NoConformidades.propTypes = {
  getNoConformidadesAction: PropTypes.func.isRequired,
  seleccionarNoConformidadAction: PropTypes.func.isRequired,
  deseleccionarNoConformidadAction: PropTypes.func.isRequired,
  resetNoConformidades: PropTypes.func.isRequired,
  logoutAction: PropTypes.func.isRequired,
  appIsOnline: PropTypes.bool.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  noConformidades: PropTypes.shape({
    listado: PropTypes.array,
    loading: PropTypes.bool,
    limit: PropTypes.number,
    start: PropTypes.number,
    page: PropTypes.number,
    totalNcVencidas: PropTypes.number,
    totalNcConAcciones: PropTypes.number,
    totalNcActivas: PropTypes.number,
    esListadoFiltrado: PropTypes.bool,
    seleccionada: PropTypes.object,
    uploadPhotosAction: PropTypes.func,
  }).isRequired,
};


function mapStateToProps({
  noConformidades, app: { online: appIsOnline }, auth, sistemaSubidaFotografias,
}) {
  return {
    noConformidades,
    appIsOnline,
    auth,
    sistemaSubidaFotografias,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getNoConformidadesAction,
    setTitleAction,
    seleccionarNoConformidadAction,
    logoutAction,
    resetNoConformidades,
    deseleccionarNoConformidadAction,
    addNotificacion,
    uploadPhotosAction,

  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(NoConformidades);
